import { ReactChild, useState } from 'react';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel';
import { CircleIcon } from './CircleIcon';

interface newElement {
    key?: number;
}
export interface OptimizedImageCarouselProps {
    images: string[];
    isMobile: boolean;
}

export const OptimizedImageCarousel = ({
    images,
    isMobile,
}: OptimizedImageCarouselProps): JSX.Element => {
    const [selectedDot, setSelectedDot] = useState(0);
    const [currentIndex, setCurrentIndex] = useState(0);

    const customRenderThumb = (children: any): ReactChild[] => {
        return children.map((item: newElement, index: number) => {
            return (
                <CircleIcon
                    key={`dot-${index}`}
                    isSelected={selectedDot === index}
                />
            );
        });
    };

    const handleChange = (index: number) => {
        setSelectedDot(index);
        setCurrentIndex(index);
    };

    // Only render images that are currently visible or adjacent (for better UX)
    const getVisibleImages = () => {
        const visibleRange = 2; // Show current + 2 before + 2 after
        const start = Math.max(0, currentIndex - visibleRange);
        const end = Math.min(images.length, currentIndex + visibleRange + 1);
        
        return images.slice(start, end).map((image, index) => ({
            src: image,
            originalIndex: start + index
        }));
    };

    return (
        <div className="w-full">
            <Carousel
                showIndicators={false}
                width="100%"
                thumbWidth={isMobile ? 25 : 30}
                interval={10000}
                autoPlay
                infiniteLoop
                renderThumbs={customRenderThumb}
                onChange={handleChange}
                swipeable={true}
                emulateTouch={true}
                showStatus={false}
                showArrows={!isMobile}
                className="carousel-container"
            >
                {images.map((image, i) => {
                    return (
                        <div key={i} className="flex items-center justify-center bg-gray-50">
                            <img
                                src={image}
                                alt={`Apartment image ${i + 1}`}
                                className="w-full h-auto object-contain max-h-[350px] lg:max-h-[450px]"
                                loading="lazy"
                            />
                        </div>
                    );
                })}
            </Carousel>
        </div>
    );
};